import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
import { UserEntity } from "../user/user.entity";
import { IdeaActivityEntity } from "./idea-activity.entity";
import { IdeaFilesEntity } from "./ideafiles.entity";

@Entity('idea')
export class IdeaEntity { 

    @PrimaryGeneratedColumn('increment',{name:'id'}) 
    Id: number; 
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"idea_text"
    })
    text:string; 
    @Column("varchar",{
        nullable:false,
        length:100,
        name:"first_name"
    })
    firstName:string; 
    @Column("varchar",{
        nullable:true,
        length:100,
        name:"last_name"
    })
    lastName:string;
    @Column("varchar",{
        nullable:true,
        length:100,
        name:"address"
    })
    address:string;
    @Column({
        type: 'int',
        nullable:true,
        name: 'village_id'
    })
    villageId: number;
    @Column("varchar",{
        nullable:false,
        length:10,
        name:"mobileNo"
    })
    mobileNo:string;
    @Column("varchar",{
        nullable: false,
        name:"email"
      })
      email:string;
      @Column({
        type: 'int',
        nullable:true,
        name: 'user_id'
    })
    userId: number;
      @Column("boolean",{
        nullable:false,
        default:true,               
        name:"status"
    })
    status:boolean;  
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;
    @Column("int", {
        nullable: true,
        name: "created_user"
    })
    createdUser: number | null;
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;
    @Column("int", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: number | null;
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
    @ManyToOne(() =>UserEntity,(user:UserEntity)=>user.idea)
    @JoinColumn({name:"user_id"})
    user:UserEntity;
    @OneToMany(() =>IdeaFilesEntity,(ideafiles:IdeaFilesEntity)=>ideafiles.idea)
    ideafiles:IdeaFilesEntity;
    @OneToMany(() =>IdeaActivityEntity,(ideactivity:IdeaActivityEntity)=>ideactivity.idea)
    ideactivity:IdeaActivityEntity;
   
}